import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid2";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import { colors } from "../../../styles/colors";
import fontWeight from "../../../styles/mui/fontWeight";
import {
  AuthContainer,
  RowTableCell,
  ProviderMaterialsHeader,
  GridContainer,
  HeaderTableCell,
  InformationGrid,
  SpanStyle,
  DownloadButton,
} from "../styles/style";
import {
  providerMaterialData,
  providerMaterialsHeaderLabel,
} from "../../../constants/ProviderMaterials";
import { ProviderMaterial } from "../../../models/ProviderMaterials";
import { getCurrnetPageFullPath, getDownloadUrl, getUaserPageViewPayload } from "../../../utils";
import { UserPageTrack } from "../../../models/User";

import { ApplicationTitles } from "../../../constants/HomePage";
import { redirectUri } from "../../../constants/Config";
import { getValidMessageType } from "../../../constants/User";

export interface PropsFromDispatch {
  postUserPageTrack: (payload: UserPageTrack) => void;
}

type AllProps = PropsFromDispatch;

const ProviderMaterials: React.FC<AllProps> = ({postUserPageTrack}) => {
  
  
  const [activeButton, setActiveButton] = useState<number | null>(null);

  const handleButtonClick = (id: number, link: string) => {
    const newTab = window.open(
      getDownloadUrl(link),
      "_blank",
      "noopener,noreferrer"
    );
    if (newTab) {
      newTab.opener = null;
      newTab.focus();
    }
    setActiveButton(id);
  };

  useEffect(() => {
    postUserPageTrack(
      getUaserPageViewPayload(
        getValidMessageType(ApplicationTitles.PROVIDER_LISTING),
        getCurrnetPageFullPath(),
        redirectUri,
        ""
      )
    );
  }, []);

  const header = () => {
    return (
      <Box sx={ProviderMaterialsHeader}>
        <Typography
          variant="h1"
          color={colors.white[1]}
          fontWeight={fontWeight[2]}
          fontSize="3.5rem"
        >
          Provider<span style={SpanStyle}>Materials</span>
        </Typography>
      </Box>
    );
  };

  const renderTableCell = (
    value: string | number,
    removeBorder: boolean,
    bold?: boolean
  ) => {
    return (
      <TableCell sx={RowTableCell(removeBorder)}>
        {renderData(value, bold)}
      </TableCell>
    );
  };

  return (
    <Box>
      <Grid container sx={GridContainer}>
        <Grid size={{ xs: 12 }} sx={AuthContainer}>
          {header()}
          <Grid size={{ xs: 12 }} sx={InformationGrid}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    {providerMaterialsHeaderLabel.map(
                      (data: string) => (
                        <TableCell key={data} sx={HeaderTableCell}>
                          {renderData(data, true, "center")}
                        </TableCell>
                      )
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {providerMaterialData &&
                    providerMaterialData.map((data: ProviderMaterial, index: number) => (
                      <TableRow key={data.providerMaterialId}>
                        {renderTableCell(
                          data.name,
                          providerMaterialData.length - 1 === index,
                          true
                        )}
                        {renderTableCell(
                          data.description,
                          providerMaterialData.length - 1 === index
                        )}
                        <TableCell
                          sx={RowTableCell(
                            providerMaterialData.length - 1 === index
                          )}
                        >
                          <Button
                              variant="contained"
                              sx={DownloadButton(
                                activeButton === data.providerMaterialId
                              )}
                              disableRipple
                              onClick={() =>
                                handleButtonClick(
                                  data.providerMaterialId,
                                  data.link
                                )
                              }
                            >
                              Download
                            </Button>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

const renderData = (value: number | string, bold?: boolean, align?: any) => {
  return (
    <Typography
      variant="h2"
      color={colors.portalColor[2]}
      fontWeight={bold ? fontWeight[7] : fontWeight[2]}
      lineHeight="1.7rem"
      align={align}
    >
      {value}
    </Typography>
  );
};

export default ProviderMaterials;
